export const AuthErrorComponent = ({error}) => {
    return <h3>An Error Occurred: {error.errorCode}</h3>;
}